import router from './router'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css'// progress bar style
import { getToken } from '@/utils/auth' // getToken from cookie

NProgress.configure({ showSpinner: false })// NProgress Configuration

/**
 * 匹配权限
 * @param userPerms 用户拥有的权限集合，后台返回来，存在vuex，数据类型是数组
 * @param routerPerm 定义的src/router/index.js的路由表asyncRouterMap中
 * @returns {*}
 */
function hasPermission(userPerms, routerPerm) {
  //特殊值，*代表所有资源权限
  if(userPerms.some(p=>p.val=="*")) return true;
  //如果菜单路由上没有声明perm属性，默认显示该菜单，代表所有人可以访问
  if(!routerPerm) return true;
  //判断用户的资源权限集合中是否包含该菜单路由声明的资源权限
  return userPerms.some(p=>p.val==routerPerm)
}

const loginRoute = "/login"
const whiteList = new Set([loginRoute,'/authredirect'])// no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start()
  let token = getToken();
  let hasToken = token != 'undefined' && token != undefined && token !=null && token != '';
  if (hasToken) {
    if (to.path == loginRoute) {
      next({ path: '/' })
      NProgress.done() // if current page is dashboard will not trigger	afterEach hook, so manually handle it
    } else {
      next();
    }
  } else {
    //先判断IP是否在范围
    if (to.path == loginRoute) {
      whiteList.has(to.path) ? next() : next(loginRoute);
    }else{
      store.dispatch('GetOrgInfoByIp').then(res => {
        console.log(' get org infor by ip res : ',res)
        next({ path: '/' })
      }).catch((err) => {
        //IP 不在范围内，用户名登录。
        console.log(' get org infor by ip error : ',err)
        whiteList.has(to.path) ? next() : next(loginRoute);
      })
      NProgress.done();
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})



// WEBPACK FOOTER //
// ./src/permission.js